import { useState } from "react";
import { Info, X } from "lucide-react";
import { RULES } from "@/game/rules";

export default function GameRulesButton({ formatId }) {
  const [open, setOpen] = useState(false);
  const rule = RULES[formatId] || RULES.medal;

  return (
    <>
      <button onClick={() => setOpen(true)} className="text-[#103B31] hover:opacity-70" data-testid="game-rules-button" title="Reglas">
        <Info size={20} />
      </button>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-[#F7F3EA] rounded-2xl p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-black text-[#102E32]" data-testid="game-rules-title">{rule.title}</h3>
              <button onClick={() => setOpen(false)} className="text-[#6B7A6F]"><X size={20} /></button>
            </div>
            <p className="text-[11px] font-bold text-[#6B7A6F] uppercase tracking-wide mt-1 mb-4">Reglas del juego</p>
            <ul className="space-y-3">
              {rule.lines.map((l, i) => (
                <li key={i} className="flex gap-2.5 items-start">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#103B31] mt-2 shrink-0" />
                  <span className="text-sm text-[#102E32] leading-relaxed">{l}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
